<div class="modal fade" id="transferModal" tabindex="-1"  role="dialog" aria-labelledby="sendModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content" *ngIf="!!case">
      <div class="modal-header p-3" *ngIf="!isOffer">
        <h5 class="modal-title" id="sendModalLabel" *ngIf="!input.cancelOrder && !input.rejectOrder">{{ 'Standard.CreateCase' | translate }}</h5>
        <h5 class="modal-title" id="cancelModalLabel" *ngIf="input.cancelOrder">{{ 'Standard.CancelCase' | translate }}</h5>
        <h5 class="modal-title" id="cancelModalLabel" *ngIf="input.rejectOrder">{{ 'Standard.RejectCase' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="openModal = false; createdCaseId = null;"><span aria-hidden="true" class="close-btn">&times;</span></button>
      </div>
      <div class="modal-header p-3" *ngIf="isOffer">
        <h5 class="modal-title" id="sendModalLabel" *ngIf="createdCaseId != null">{{ 'Notifications.NewOfferMessage' | translate }}</h5>
        <h5 class="modal-title" id="sendModalLabel" *ngIf="createdCaseId == null">{{ 'Buttons.AcceptReject' | translate }} {{ ('Standard.Offer' | translate) | lowercase }}</h5>
      </div>
      <div class="modal-body pl-3 pr-3 pt-1 pb-1" *ngIf="input.cancelOrder && !input.rejectOrder && !input.selectPartner">
        {{ 'Standard.CancelConfirmationText' | translate }}?
      </div>
      <div class="modal-body" *ngIf="!input.cancelOrder && input.rejectOrder && !input.selectPartner && createdCaseId == null">
        <div class="row">
          <div class="col-12"><h3>{{ 'Standard.RejectConfirmationText' | translate }}?</h3></div>
        </div>
      </div>
      <div class="modal-body" *ngIf="case != null && !input.cancelOrder && !input.rejectOrder && !input.selectPartner && createdCaseId == null">
        <!--Customer Address Manipulator-->
        <div class="row">
          <div class="col-12">
            <app-customer-address [step]="data.step"
                                  [customerId]="case.customer.customerId"
                                  [deliveryId]="case.deliveryAddress.id"
                                  [contactId]="case.contactAddress.id"
                                  [notification]="case.caseNotificationAddress"
                                  [newCaseCustomer]="newCaseCustomer"
                                  [do]="data.documentAddressMessage"
                                  (com)="documentAddressChange($event)"
                                  (update)="documentAddressChange($event)">
            </app-customer-address>
          </div>
          <div class="col-12 d-flex justify-content-between mb-3">
            <button class="btn btn-primary" *ngIf="data.step != 'final'" (click)="data.step = 'final'">{{ 'Buttons.Back' | translate }}</button>
            <div *ngIf="case.caseId == null">
              <button class="btn btn-success" *ngIf="data.step == 'final'" (click)="data.step = 'chooseCustomer';">{{ 'Buttons.ConnectToExistingCustomer' | translate }}</button>
              <button class="btn btn-success" *ngIf="data.step == 'editCustomer'" (click)="data.step = 'final'; data.documentAddressMessage = 'back'">{{ 'Buttons.Save' | translate }}</button>
              <button class="btn btn-success" *ngIf="data.step == 'chooseDelivery'" (click)="data.step = 'final'; data.documentAddressMessage = 'back'">{{ 'Standard.Choose' | translate }}</button>
              <button class="btn btn-success" *ngIf="data.step == 'chooseContact'" (click)="data.step = 'final'; data.documentAddressMessage = 'back'">{{ 'Standard.Choose' | translate }}</button>
              <button class="btn btn-success" *ngIf="data.step == 'chooseCustomer'" (click)="data.step = 'final'; customerChange = true; data.documentAddressMessage = 'back'">{{ 'Standard.Choose' | translate }}</button>
            </div>
            <div *ngIf="case.caseId != null">
              <button class="btn btn-success mr-3" *ngIf="data.step == 'editCustomer'" (click)="data.step = 'chooseCustomer'">{{ 'Buttons.ChangeCustomer' | translate }}</button>
              <button class="btn btn-success" *ngIf="data.step == 'editCustomer'" (click)="data.step = 'final'; data.documentAddressMessage = 'editCustomer'">{{ 'Buttons.Save' | translate }}</button>
              <button class="btn btn-success" *ngIf="data.step == 'chooseDelivery'" (click)="data.step = 'final'; data.documentAddressMessage = 'chooseDelivery'">{{ 'Standard.Choose' | translate }}</button>
              <button class="btn btn-success" *ngIf="data.step == 'chooseContact'" (click)="data.step = 'final'; data.documentAddressMessage = 'chooseContact'">{{ 'Standard.Choose' | translate }}</button>
              <button class="btn btn-success" *ngIf="data.step == 'chooseCustomer'" (click)="data.step = 'final'; customerChange = true; data.documentAddressMessage = 'chooseCustomer'">{{ 'Standard.Choose' | translate }}</button>
            </div>
          </div>
        </div>
        <!--Case Settings-->
        <div class="row">
          <div class="col-12">
            <h3>{{ 'Shop.TaskDetails' | translate }}</h3>
            <div class="row">
              <div class="col-6 col-md-auto" *ngIf="type != 'partner' && case.transferTypeId != '9c6c331e-5959-4163-b028-e27b7e28b76e'">
                <div class="form-group mb-0">
                  <label class="mb-0" for="responsible">{{ 'Standard.Responsible' | translate }}</label>
                  <select class="form-control" id="responsible" [(ngModel)]="case.responsible.responsibleId" (change)="changeResponsible()">
                    <option *ngFor="let x of data.responsibles" [value]="x.key">{{ x.value }}</option>
                  </select>
                </div>
              </div>
              <div class="col-6 col-md-auto" *ngIf="type != 'partner' && !data.lightCustomer && data.integrationId != '7e82cc3e-163e-4cb2-ba25-939fc339f021' && case.transferTypeId != '9c6c331e-5959-4163-b028-e27b7e28b76e'">
                <div class="form-group mb-0">
                  <label class="mb-0" for="foreman">{{ 'Standard.Foreman' | translate }}</label>
                  <select class="form-control" id="foreman" [(ngModel)]="foreman.key">
                    <option *ngFor="let x of data.companyUsers" [value]="x.userId">{{ x.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-6 col-md-auto" *ngIf="type != 'partner' && !data.lightCustomer && data.integrationId == '58ecfda6-79a6-4507-80ac-29b6d025360b' && data.departments">
                <div class="form-group mb-0">
                  <label for="department" class="mb-0">{{ 'Standard.Department' | translate }}</label>
                  <select id="department" class="form-control" [(ngModel)]="case.departmentId">
                    <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                    <option [ngValue]="x.id" *ngFor="let x of data.departments">{{ x.text }}</option>
                  </select>
                </div>
              </div>
              <div class="col-6 col-md-auto" *ngIf="type != 'partner' && !data.lightCustomer && data.integrationId == '58ecfda6-79a6-4507-80ac-29b6d025360b' && !!data.osStatuses">
                <div class="form-group mb-0">
                  <label for="department" class="mb-0"> Ordrestyring {{ 'Standard.Status' | translate }}</label>
                  <select id="department" class="form-control" [(ngModel)]="osStatus">
                    <option [ngValue]="x.id" *ngFor="let x of data.osStatuses">{{ x.text }}</option>
                  </select>
                </div>
              </div>
              <div class="col-6 col-md-auto" *ngIf="case.transferTypeId != '9c6c331e-5959-4163-b028-e27b7e28b76e'">
                <div class="form-group mb-0">
                  <label class="mb-0" for="requisitionNo">{{ 'Standard.Requisition' | translate }}</label>
                  <input type="text" class="form-control" id="requisitionNo" [(ngModel)]="case.requisitionNumber">
                </div>
              </div>
              <div class="col-6 col-md-auto" *ngIf="case.transferTypeId != '9c6c331e-5959-4163-b028-e27b7e28b76e'">
                <div class="form-group mb-0">
                  <label class="mb-0" for="ourReference">{{ 'Standard.Reference' | translate }}</label>
                  <input type="text" class="form-control" id="ourReference" [(ngModel)]="case.vorRef">
                </div>
              </div>
              <div class="col-6 col-md-auto" *ngIf="data.caseTypes != undefined && data.caseTypes.length > 0 && type != 'partner' && data.integrationId == '58ecfda6-79a6-4507-80ac-29b6d025360b'">
                <div class="form-group mb-0">
                  <label class="mb-0" for="caseType">{{ 'Standard.CaseType' | translate }}</label>
                  <select class="form-control" id="caseType" [(ngModel)]="input.caseTypeId">
                    <option *ngFor="let x of data.caseTypes" [ngValue]="x.id">{{ x.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-6 col-md-auto" *ngIf="data.customerTypes != undefined && type != 'partner' && data.customerTypes.length > 0 && data.integrationId == '58ecfda6-79a6-4507-80ac-29b6d025360b'">
                <div class="form-group mb-0">
                  <label class="mb-0" for="caseType">{{ 'Standard.CustomerType' | translate }}</label>
                  <select class="form-control" id="customerType" [(ngModel)]="input.customerTypeId">
                    <option *ngFor="let x of data.customerTypes" value="{{ x.id }}">{{ x.text }}</option>
                  </select>
                </div>
              </div>
              <div class="col-6 col-md-auto" *ngIf="type != 'partner' && data.debitorTypes != null && data.debitorTypes.length > 0 && data.integrationId == '58ecfda6-79a6-4507-80ac-29b6d025360b'">
                <div class="form-group mb-0">
                  <label class="mb-0" for="caseType">{{ 'Standard.DebtorGroup' | translate }}</label>
                  <select class="form-control" id="debitorType" [(ngModel)]="input.debitorTypeId">
                    <option *ngFor="let x of data.debitorTypes" value="{{ x.number }}">{{ x.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-6 col-md-auto" *ngIf="data.integrationId == '7e82cc3e-163e-4cb2-ba25-939fc339f021'">
                <div class="form-group mb-0">
                  <label class="mb-0" for="caseType">{{ 'Standard.OrderGroup' | translate }}</label>
                  <select class="form-control" [(ngModel)]="currentEOrderGroup">
                    <option [ngValue]="null">{{'Standard.Choose' | translate }}</option>
                    <option *ngFor="let x of eorderGroupList" value="{{ x.id }}">{{ x.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-6 col-md-auto" *ngIf="data.integrationId == '7e82cc3e-163e-4cb2-ba25-939fc339f021'">
                <div class="form-group mb-0">
                  <label class="mb-0" for="caseType">{{ 'Standard.Department' | translate }}</label>
                  <select class="form-control" [(ngModel)]="currentEDepartment">
                    <option [ngValue]="null">{{'Standard.Choose' | translate }}</option>
                    <option *ngFor="let x of edepartmentList" value="{{ x.id }}">{{ x.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-6 col-md-auto" *ngIf="data.integrationId == '7e82cc3e-163e-4cb2-ba25-939fc339f021'">
                <div class="form-group mb-0">
                  <label class="mb-0" for="caseType">{{ 'Standard.Carrier' | translate }}</label>
                  <select class="form-control" [(ngModel)]="currentEDimensionCarrier">
                    <option [ngValue]="null">{{'Standard.Choose' | translate }}</option>
                    <option *ngFor="let x of edimensionCarrierList" value="{{ x.id }}">{{ x.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-6 col-md-auto" *ngIf="data.integrationId == '7e82cc3e-163e-4cb2-ba25-939fc339f021'">
                <div class="form-group mb-0">
                  <label class="mb-0" for="caseType">{{ 'Standard.PriceGroup' | translate }}</label>
                  <select class="form-control" [(ngModel)]="currentEPriceGroup">
                    <option [ngValue]="null">{{'Standard.Choose' | translate }}</option>
                    <option *ngFor="let x of epriceGroupList" value="{{ x.id }}">{{ x.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-6 col-md-auto" *ngIf="data.integrationId == '7e82cc3e-163e-4cb2-ba25-939fc339f021'">
                <div class="form-group mb-0">
                  <label class="mb-0" for="caseType">{{ 'Standard.ProfitGroup' | translate }}</label>
                  <select class="form-control" [(ngModel)]="currentEProfitGroup">
                    <option [ngValue]="null">{{'Standard.Choose' | translate }}</option>
                    <option *ngFor="let x of eProfitGroupList" value="{{ x.id }}">{{ x.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-6 col-md-auto" *ngIf="data.integrationId == '7e82cc3e-163e-4cb2-ba25-939fc339f021'">
                <div class="form-group mb-0">
                  <label class="mb-0" for="caseType">Formål</label>
                  <select class="form-control" [(ngModel)]="currentEDimensionPurpose">
                    <option [ngValue]="null">Vælg</option>
                    <option *ngFor="let x of eDimensionPuposeList" value="{{ x.id }}">{{ x.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-6 col-md-auto" *ngIf="data.integrationId == '7e82cc3e-163e-4cb2-ba25-939fc339f021'">
                <div class="form-group mb-0">
                  <label class="mb-0" for="caseType">Sagstype</label>
                  <select class="form-control" [(ngModel)]="currentCaseType">
                    <option [ngValue]="null">Vælg</option>
                    <option value="spjæld">Spjæld</option>
                    <option value="enterprise">Enterprise</option>
                  </select>
                </div>
              </div>
              <div class="col-12 mt-2" *ngIf="data.activeIntegration == '58ecfda6-79a6-4507-80ac-29b6d025360b'">
                <label>{{ 'Transfer.MakeCaseToSubCase' | translate }}</label>
                <case-search (case)="parentCase($event)"></case-search>
              </div>
              <div class="col-12 mt-2">
                <div class="form-group mb-0">
                  <label for="title">{{ 'Standard.Title' | translate }}</label>
                  <input type="text" class="form-control" id="title" [(ngModel)]="case.title">
                </div>
              </div>
              <div class="col-12 mt-2">
                <div class="form-group mb-0">
                  <label class="mb-0" for="description">{{ 'Standard.Description' | translate }}</label>
                  <textarea class="form-control" id="description" rows="3" [(ngModel)]="case.description"></textarea>
                  <span class="red ml-1" *ngIf="case.description == null || case.description == ''">{{ 'Standard.MissingDescription' | translate }}</span>
                </div>
              </div>
              <div class="col-12 mt-2">
                <div class="form-group mb-0">
                  <label for="internalRemark">{{ 'Standard.InternalRemark' | translate }}</label>
                  <textarea class="form-control form-control-sm" [(ngModel)]="case.internalNote" rows="3"></textarea>
                </div>
              </div>
              <div class="col-12 mt-2" *ngIf="newCaseCustomer?.files.length > 0">
                <div class="from-group mb-0">
                  <app-image-viewer [images]="newCaseCustomer.files" [options]="{'upload':false}"></app-image-viewer>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Task Planning-->
        <div class="row mt-3" *ngIf="type != 'partner' && case.caseId != null">
          <div class="col-12">
            <h3>{{ 'Standard.Planned' | translate }}</h3>
            <div class="row">
              <div class="col-3 form-group mb-0">
                <label class="mb-0 w-100" for="planDate">{{ 'Standard.Date' | translate }}</label>
                <div class="input-group" *ngIf="!!data.companyInfo">
                  <input type="text"
                    class="form-control"
                    id="planDate"
                    placeholder="{{ 'Date.SelectDate' | translate }}"
                    bsDatepicker
                    #planDatePicker="bsDatepicker"
                    [bsConfig]="bsConfig"
                    (bsValueChange)="input.planDate = $event?.toISOString()">
                  <div class="input-group-append">
                    <button type="button" class="btn btn-secondary" *ngIf="input.planDate" (click)="input-planDate = null">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                  <!-- toggle calendar button -->
                  <div class="input-group-append">
                    <button type="button" class="btn btn-secondary" (click)="planDatePicker.toggle()">
                      <i class="far fa-calendar-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col form-group mb-0 pl-0 pr-0">
                <label class="mb-0" for="planTime">{{ 'Standard.Time' | translate }}</label>
                <select class="form-control" [(ngModel)]="input.planTime" id="planTime">
                  <option *ngFor="let x of time.dueTimes">{{ x }}</option>
                </select>
              </div>
              <div class="col form-group mb-0 pr-0">
                <label class="mb-0" for="planHours">{{ ('Standard.Hours'  | translate) | titlecase }}</label>
                <select class="form-control" [(ngModel)]="input.planHours" id="planHours">
                  <option *ngFor="let x of time.durationHours">{{ x }}</option>
                </select>
              </div>
              <div class="col form-group mb-0 pr-0">
                <label class="mb-0" for="planMinutes">{{ ('Standard.Minutes'  | translate) | titlecase }}</label>
                <select class="form-control" [(ngModel)]="input.planMinutes" id="planMinutes">
                  <option *ngFor="let x of time.durationMinutes">{{ x }}</option>
                </select>
              </div>
              <div class="col-3 form-group pr-0 mb-0">
                <label class="mb-0" for="planFitter">{{ 'Standard.AssignedTo' | translate }}</label>
                <select [(ngModel)]="input.planFitter" class="form-control" id="planFitter">
                  <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                  <option *ngFor="let x of data.companyUsers" value="{{ x.userId }}">{{ x.name }}</option>
                </select>
              </div>
              <div class="col-auto text-right m-auto">
                <span (click)="createTask()"><i class="fas fa-plus-square fa-2x mt-3 mb-0"></i></span>
              </div>
              <div class="col-12 text-danger" *ngIf="!planDate && creatingTask">{{'CaseTransfer.YouNeedToChooseADateForPlanning' | translate }}</div>
            </div>
            <div class="row mt-">
              <div class="col-12 mt-2">
                <table class="table table-striped table-sm mb-0" aria-label="Fitter tasks">
                  <thead>
                    <tr>
                      <th scope="col">{{ 'Standard.Fitter' | translate }}</th>
                      <th scope="col">{{ 'Standard.StartTime' | translate }}</th>
                      <th scope="col">{{ 'Standard.EndTime' | translate }}</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody *ngIf="input.caseTask != null">
                    <tr>
                      <td>{{ input.caseTask.fitter.value? input.caseTask.fitter.value: ''  }}</td>
                      <td>{{ (input.caseTask.startDateTime)? (input.caseTask.startDateTime + 'Z' | date:'dd-MM HH:mm'):'' }}</td>
                      <td>{{ (input.caseTask.endDateTime)? (input.caseTask.endDateTime + 'Z' | date:'dd-MM HH:mm'):'' }}</td>
                      <td class="text-right"><span (click)="deleteTask()"><i class="fas fa-trash"></i></span></td>
                    </tr>
                  </tbody>
                  <tbody *ngIf="input.caseTask == null">
                    <tr>
                      <td colspan="4" class="text-center">{{ 'Standard.CaseWithoutTime' | translate }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body pb-0" *ngIf="!input.cancelOrder && !input.rejectOrder && input.selectPartner && createdCaseId == null">
        <div class="row">
          <div class="col-12 mb-3">
            <input class="form-control" type="text" [(ngModel)]="input.partnerFilter" (keyup)="filterPartner()" placeholder="{{ 'Standard.Search' | translate }} {{ ('Standard.Partner' | translate ) | lowercase }}" />
          </div>
          <div class="col-12">
            <div class="row pl-3 pr-3 pb-0">
              <div class="col-4 d-flex p-1" *ngFor="let x of data.showPartners" (click)="x.customerId != null ? input.chosenPartner = x.companiesToPartnerId : null;" [ngClass]="input.chosenPartner == x.companiesToPartnerId ? 'partner chosen' : '' || x.customerId == null ? 'partner-nan' : 'partner'">
                <div><img class="partnerImage mr-3" src="https://jubloapi.azure-api.net/api/shared/attachments/{{ x.logo }}" alt="" /></div>
                <div class="partnerAddress">
                  <div>{{ x.companyName }}</div>
                  <div>{{ x.address }}</div>
                  <div>{{ x.zipCode }} {{ x.city }}</div>
                </div>
                <div class="text-right">
                  <div class="partnerData">{{ x.vat }}</div>
                  <div class="partnerData">{{ x.companyNumber }}</div>
                  <div class="partnerData text-danger" *ngIf="x.customerId == null">{{ 'Messages.Pending' | translate }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body" *ngIf="createdCaseId != null">
        <div class="row">
          <div class="col-12">
            {{ isOffer ? ('Standard.OfferCreated' | translate) : ('Standard.CaseCreated' | translate) }}
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-between align-items-end">
        <button hidden id="transferCaseCloseModalBtn" data-dismiss="modal"></button>
        <div>
          <button type="button" class="btn btn-secondary" (click)="openModal = false; createdCaseId = null; popperCheck()" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
        </div>
        <div *ngIf="createdCaseId == null">
          <div *ngIf="!input.cancelOrder && !input.rejectOrder">
            <button type="button" class="btn btn-danger" (click)="input.cancelOrder = !input.cancelOrder" *ngIf="transferCase">{{ 'Buttons.Cancel' | translate }}</button>
            <button type="button" class="btn btn-danger" (click)="input.rejectOrder = !input.rejectOrder" *ngIf="!transferCase">{{ 'Buttons.Reject' | translate }}</button>
          </div>
          <div *ngIf="!input.cancelOrder && !input.selectPartner && !!case.caseId">
            <button type="button" class="btn btn-primary" (click)="input.selectPartner = !input.selectPartner; getPartners()" [disabled]="noPartners" *ngIf="type == 'partner'">{{ 'Buttons.Next' | translate }}</button>
            <a href="http://jublo.com/partner/" target="_blank" class="ml-3" *ngIf="noPartners" rel="noopener">{{ 'Buttons.ReadMoreHere' | translate }} <i class="far fa-question-circle"></i></a>
          </div>
        </div>
        <div *ngIf="!!case.caseId">
          <button type="button" class="btn btn-success" (click)="goToCase()" data-dismiss="modal">{{ isOffer ? ('Buttons.GoToOffer' | translate) : ('Buttons.GoToCase' | translate) }}</button>
        </div>
        <div *ngIf="isOffer && createdCaseId == null">
          <button type="button" class="btn btn-success" (click)="acceptOffer()" [disabled]="loading || !!dblClick">
            <span *ngIf="!loading && dblClick == null">{{ 'Buttons.AcceptOffer' | translate }}</span>
            <span *ngIf="loading || dblClick != null"><i class="fa fa-spinner fa-spin"></i></span>
          </button>
        </div>
        <div class="form-group" *ngIf="!!case.transferTypeId">
          <label>{{ 'Case.AddAsMessageOnCase' | translate }}</label>
          <case-search (case)="!!$event ? receiverCaseId = $event.caseId : receiverCaseId = null"></case-search>
        </div>
        <div *ngIf="!isOffer && createdCaseId == null">
          <button type="button" class="btn btn-success mr-1" [disabled]="!receiverCaseId || !!transferMessage" (click)="AddMessageToCase()" *ngIf="!!case.transferTypeId" data-dismiss="modal">{{ 'Transfer.AddMessageToCase' | translate }}</button>
          <button id="btnAccept" type="button" class="btn btn-outline-success" (click)="checkPhoneOnIntegration(false)" 
          *ngIf="!input.cancelOrder && !input.rejectOrder && !input.selectPartner && type != 'partner' && !receiverCaseId" [disabled]="loading || dblClick != null">
            <span *ngIf="!loading">
              {{ 'Buttons.Accept' | translate }}
            </span>
            <span *ngIf="loading"><i class="fa fa-spinner fa-spin"></i></span>
          </button>
          <button id="btnAccept" type="button" class="btn btn-success btn-{{ originName(data.activeIntegration) }} ml-3" (click)="checkPhoneOnIntegration(true)" 
          *ngIf="!data.lightCustomer && !input.cancelOrder && !input.rejectOrder && !input.selectPartner && type != 'partner'" [disabled]="loading || dblClick != null">
            <span *ngIf="!loading">
              <span *ngIf="case.caseId == null">{{ 'Buttons.Accept' | translate }} {{ 'Standard.AndTransferTo' | translate }}</span>
              <span *ngIf="case.caseId != null">{{ 'Standard.SendTo' | translate }} </span>
              {{ originName(data.activeIntegration) }}
            </span>
            <span *ngIf="loading"><i class="fa fa-spinner fa-spin"></i></span>
          </button>
          <button type="button" class="btn btn-danger" (click)="cancelCase(case.caseId)" data-dismiss="modal" *ngIf="input.cancelOrder">{{ 'Buttons.Cancel' | translate }}</button>
          <button type="button" class="btn btn-danger" (click)="rejectCase()" data-dismiss="modal" *ngIf="input.rejectOrder">{{ 'Buttons.Reject' | translate }}</button>
          <div id="tooltip" (click)="popper()" hidden class="popover">{{'AlertMessage.Number' | translate}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
<button hidden id="transferCaseModalOpener" #transferCaseModalOpener data-toggle="modal" data-target="#transferModal"></button>
